module.exports = __webpack_public_path__ + "static/img/jiegou.eb8b6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/jiegou.png
// module id = D/u5
// module chunks = 0